import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellDate } from '../../table/cells/CellDate';

export const ModelCellDateBase = (props: TableInheritedProps) => (
  <CellDate {...props} />
);

export const ModelCellDate = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute('ModelCellDate', ModelCellDateBase, props);
